export const FORM_DETAILS = {
  LOAD: 'FORM_DETAILS_LOAD',
  SUCCESS: 'FORM_DETAILS_SUCCESS',
  FAIL: 'FORM_DETAILS_FAIL',
};
export const CREATE_FORM = {
  LOAD: 'CREATE_FORM_LOAD',
  SUCCESS: 'CREATE_FORM_SUCCESS',
  FAIL: 'CREATE_FORM_FAIL',
};
export const UPDATE_FORM = {
  LOAD: 'UPDATE_FORM_LOAD',
  SUCCESS: 'UPDATE_FORM_SUCCESS',
  FAIL: 'UPDATE_FORM_FAIL',
};
export const DELETE_FORM = {
  LOAD: 'DELETE_FORM_LOAD',
  SUCCESS: 'DELETE_FORM_SUCCESS',
  FAIL: 'DELETE_FORM_FAIL',
};
export const FORMS_LISTING = {
  LOAD: 'FORMS_LISTING_LOAD',
  SUCCESS: 'FORMS_LISTING_SUCCESS',
  FAIL: 'FORMS_LISTING_FAIL',
  RESET: 'FORMS_LISTING_RESET',
};
export const FORM_AUDIENCE = {
  LOAD: 'FORM_AUDIENCE_LOAD',
  SUCCESS: 'FORM_AUDIENCE_SUCCESS',
  FAIL: 'FORM_AUDIENCE_FAIL',
  RESET: 'FORM_AUDIENCE_RESET',
  RESET_LIST_ONLY: 'FORM_AUDIENCE_RESET_LIST_ONLY',
};

export const FORM_SEARCH_AUDIENCE = {
  LOAD: 'FORM_SEARCH_AUDIENCE_LOAD',
  SUCCESS: 'FORM_SEARCH_AUDIENCE_SUCCESS',
  FAIL: 'FORM_SEARCH_AUDIENCE_FAIL',
  RESET: 'FORM_SEARCH_AUDIENCE_RESET',
  SET_SEARCH_TERM: 'FORM_SEARCH_AUDIENCE_SET_SEARCH_TERM',
  RESET_SEARCH_TERM: 'FORM_SEARCH_AUDIENCE_RESET_SEARCH_TERM',
};

export const FORM_AUDIENCE_ADD_NEW_LIST = {
  LOAD: 'FORM_AUDIENCE_ADD_NEW_LIST_LOAD',
  SUCCESS: 'FORM_AUDIENCE_ADD_NEW_LIST_SUCCESS',
  FAIL: 'FORM_AUDIENCE_ADD_NEW_LIST_FAIL',
};

export const FORM_AUDIENCE_FILTER = {
  SET_DATE_SELECTION: 'FORM_AUDIENCE_FILTER_SET_DATE_SELECTION',
  SET_DATE: 'FORM_AUDIENCE_FILTER_SET_DATE',
  RESET: 'FORM_AUDIENCE_FILTER_RESET',
};
